module.exports = __webpack_public_path__ + "files/92efe7ddd666a3992224abf8aaf6ccec.svg";